import { Suspense } from 'react';
import { Skeleton } from '@sara/ui/components/skeleton';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { InterviewTypeDetailContainerContent } from './InterviewTypeDetailContainerContent';
import type { InterviewTypeDetailContainerProps } from './types';

export type { InterviewTypeDetailContainerProps };

function InterviewTypeDetailSkeleton() {
  return (
    <div className="space-y-6">
      <Skeleton className="h-10 w-64" />
      <Skeleton className="h-[200px] rounded-lg" />
      <Skeleton className="h-[300px] rounded-lg" />
    </div>
  );
}

export function InterviewTypeDetailContainer(props: InterviewTypeDetailContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<InterviewTypeDetailSkeleton />}>
        <InterviewTypeDetailContainerContent {...props} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
